// ----------------------------------------------------------------------

import Page from "../components/Page";

export default function Settings() {
  return <Page title="Settings">Settings</Page>;
}
